export enum BACKEND_URL_LIST {
    PRODUCTION = 'https://production.backend.spacefill.fr',
    STAGING = 'https://staging.backend.spacefill.fr',
    SANDBOX = 'https://sandbox.backend.spacefill.fr',
}

export enum ATTACHMENTS_URL_LIST {
    PRODUCTION = 'https://prod-attachments-s3.s3.eu-west-3.amazonaws.com',
    STAGING = 'https://spacefill-staging-attachments.s3.eu-west-3.amazonaws.com',
    SANDBOX = 'https://spacefill-sandbox-attachments.s3.eu-west-3.amazonaws.com',
}

export const BACKEND_LIST_LABEL = {
    LOCAL: 'Local',
    PRODUCTION: 'Production',
    STAGING: 'Staging',
    SANDBOX: 'Sandbox',
};

export const BACKEND_LIST = {
    LOCAL: 'LOCAL',
    PRODUCTION: 'PRODUCTION',
    STAGING: 'STAGING',
    SANDBOX: 'SANDBOX',
};
